/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

export type WaiverType = 'components' | 'containers';
export type WaiverView = 'existing' | 'requested';
export type WaiverFilterId = 'status' | 'threat' | 'policy' | 'repository';

export interface WaiverRow {
  id: string;
  status: string;
  createTime: number | null;
  expiryTime: number | null;
  scopeOwnerType: string | null;
  scopeOwnerId: string | null;
  scopeOwnerName: string | null;
  policyId: string | null;
  policyName: string | null;
  threatLevel: number;
  displayName: string | null;
  reasonText: string | null;
  comment: string | null;
  componentUpgradeAvailable: boolean | null;
  repositoryId: string | null;
  repositoryName: string | null;
  requestedBy: string | null;
}

export interface WaiverListResponse {
  total: number;
  results: WaiverRow[];
  counts: Partial<Record<WaiverFilterId, Record<string, number>>>;
}

/** Everything the list depends on. It lives in the URL, so a reload or a shared link shows the same list. */
export interface WaiversListState {
  type: WaiverType;
  view: WaiverView;
  status: string[];
  threat: string[];
  policy: string[];
  repository: string[];
  q: string;
  sort: string | null;
  dir: 'asc' | 'desc';
  page: number;
  pageSize: number;
}

export const DEFAULT_PAGE_SIZE = 20;
